import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120SSchM1 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Schedule M-1 Form 1120-S Income Reconciliation | TaxZerone"
          description="Learn how to complete Schedule M-1 (Form 1120-S) to reconcile your S corporation's book income with taxable income accurately and maintain IRS compliance."
          keywords=""
          canonical="resources/business-tax/schedule-m-1/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule M-1</span>
          </span>{' '}
          (Form 1120-S)
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-m-1/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule M-1 (Form 1120-S) at a glance
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule M-1 (Form 1120-S)
                        </strong>{' '}
                        and how S corporations use it to reconcile differences
                        between book income reported in financial records and
                        taxable income reported on the IRS tax return.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule M-1 line by line,
                        </strong>{' '}
                        including adjustments for income, expenses,
                        depreciation, tax-exempt income, non-deductible
                        expenses, and other book-to-tax differences.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand temporary and permanent differences
                        </strong>{' '}
                        and how accounting methods, IRS tax rules, and timing
                        adjustments affect the reconciliation between financial
                        statement income and taxable income.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Schedule M‑1 (
                      <Link
                        href="/business-tax/efile-irs-form-1120-s/"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 1120‑S
                      </Link>
                      ) is a critical part of an S corporation’s annual tax
                      return, used to reconcile discrepancies between the net
                      income shown in the company’s books and the taxable income
                      reported to the IRS.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      These differences emerge because financial accounting (
                      <span style={{ fontWeight: 600 }}>GAAP</span>) rules often
                      differ from tax accounting requirements. Schedule M‑1
                      bridges that gap, providing the IRS with a transparent
                      explanation of how your corporation arrived at its final
                      taxable figure on Form 1120‑S.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Accurate reconciliation not only prevents errors but also
                      supports audit readiness, ensuring that book income, tax
                      returns, and financial statements align consistently.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What Is Schedule M‑1 (Form 1120‑S)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#purpose" sx={{ color: '#0202ff' }}>
                          Purpose of Schedule M‑1
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Schedule M‑1?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#schm1" sx={{ color: '#0202ff' }}>
                          Schedule M-1 (Form 1120-S) Line-by-Line Guide
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#relation" sx={{ color: '#0202ff' }}>
                          Relation to Schedules L and M‑2
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Schedule M‑1 Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What Is Schedule M‑1 (Form 1120‑S)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M‑1 is officially titled “Reconciliation of Income
                  (Loss) per Books with Income (Loss) per Return.” It identifies
                  and explains the timing and permanent differences between what
                  your corporation records under GAAP and what’s reported to the
                  IRS for tax purposes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Common reasons for these differences include:
                </Typography>

                <Typography variant="body1" component="div">
                  <ul style={{ marginBottom: 24 }}>
                    <li style={{ marginBottom: 16 }}>
                      Depreciation and amortization method variations
                    </li>
                    <li style={{ marginBottom: 16 }}>
                      Non‑deductible business expenses (e.g., meals, fines,
                      penalties)
                    </li>
                    <li style={{ marginBottom: 16 }}>
                      Tax‑exempt income (e.g., municipal bond interest)
                    </li>
                    <li>
                      Differences in recognizing bad debts, accrued expenses, or
                      payouts{' '}
                    </li>
                  </ul>
                </Typography>

                <Typography variant="body1" sx={{ mb: 4 }}>
                  By explicitly itemizing these adjustments, Schedule M‑1 helps
                  ensure your tax return reflects both financial reality and
                  regulatory compliance.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="purpose"
                >
                  Purpose of Schedule M‑1
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Corporate income reported on financial statements rarely
                  matches income reported on Form 1120‑S. The reasons fall into
                  two main categories:
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Temporary Differences
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Items that reverse over time, such as:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 3 }}>
                  <li>
                    Accelerated tax depreciation vs. straight‑line book
                    depreciation
                  </li>
                  <li>
                    Accrued bonuses or wages deductible for tax only when paid
                  </li>
                  <li>
                    Installment sale income recognized earlier for books than
                    tax
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. Permanent Differences
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Items that never reverse, such as:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 1.5 }}>
                  <li>Non‑deductible entertainment expenses</li>
                  <li>
                    Federal income tax expense (disallowed deduction for S
                    corps)
                  </li>
                  <li>Tax‑exempt interest income</li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Schedule M‑1 shows how these differences contribute to income
                  variations between book accounting and tax reporting.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Schedule M‑1?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  An S corporation must complete Schedule M‑1 if it does not
                  meet the small‑business exemption under Schedule B, Line 11.
                  You must file Schedule M‑1 if either of these applies:
                </Typography>
                <Box component="ul" sx={{ mb: 1.2, '& li': { mb: 1.2 } }}>
                  <li>Total assets exceed $250,000 at year‑end, or </li>
                  <li>
                    Total receipts (gross income) exceed $250,000 for the tax
                    year.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Small S corporations under both thresholds can omit Schedules
                  L and M‑1, but accurate recordkeeping is still strongly
                  advised.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="schm1"
                >
                  Schedule M-1 (Form 1120-S) Line-by-Line Guide
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Use Schedule M-1 to explain the differences between the
                  corporation's book income (financial records) and taxable
                  income reported on the tax return.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1120s-schm1-img.webp" />
                  <source srcSet="/assets/images/f1120s-schm1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1120s-schm1-img.png"
                    loading="lazy"
                    alt="Form 1120-S Schedule M-1 showing reconciliation of income (loss) per books with income (loss) per return"
                    width={760}
                    height={242}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 1 – Net Income (Loss) per Books
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the corporation's net income(loss) as reflected in your
                  financial (book) records for the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 2—Income Included on Schedule K, Lines 1, 2, 3c, 4, 5a,
                  6, 7, 8a, 9, and 10, Not Recorded on Books This Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter any income amounts reported on Schedule K that were not
                  recorded in the company's books during the year. List each
                  item separately.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 3 – Expenses Recorded on Books This Year Not Included on
                  Schedule K, Lines 1 Through 12e, and 16f
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter expenses that appear in your books but are not
                  deductible on Schedule K. Itemize each amount.
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Line 3a – Depreciation
                    </span>{' '}
                    <br />
                    Enter the depreciation amount recorded on the books that
                    exceeds the depreciation claimed on the tax return.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Line 3b – Travel and Entertainment
                    </span>{' '}
                    <br />
                    Enter travel and entertainment expenses recorded in the
                    books that are non-deductible for tax purposes.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 4—Total
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add Lines 1 through 3 Enter the total here.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 5 – Income Recorded on Books This Year Not Included on
                  Schedule K, Lines 1 Through 10
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter income amounts that appear in the corporation's books
                  but are not reportable on Schedule K Lines 1 through 10.
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Line 5a – Tax-Exempt Interest
                    </span>{' '}
                    <br />
                    Enter any interest income that is exempt from federal income
                    tax.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 6 – Deductions Included on Schedule K, Lines 1 Through
                  12e, and 16f, Not Charged Against Book Income This Year
                  (Itemize)
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  Enter deductions taken on Schedule K that were not recorded as
                  expenses in the books.
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Line 6a – Depreciation
                    </span>{' '}
                    <br />
                    Enter the amount by which tax depreciation claimed on the
                    return exceeds the depreciation recorded in the books.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 7 – Add Lines 5 and 6:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Total Lines 5 and 6. Enter the combined sum here.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 8—Income (Loss) (Schedule K, Line 18)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Subtract Line 7 from Line 4 to arrive at the corporation's
                  income or loss per the tax return. This figure must match the
                  amount reported on Schedule K, Line 18.
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong style={{ fontWeight: 600 }}> Example:</strong> If Line
                  4 is $50,000 and Line 7 is $15,000, then Line 8 is $35,000
                  (50,000 − 15,000 = 35,000). Please ensure it matches Schedule
                  K, Line 18.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Formula: Line 8 = Line 4 − Line 7
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note :</b>
                  <i>
                    {' '}
                    Schedule M-1 is required when book income and taxable income
                    differ. Ensure all reconciling items are properly reported
                    and supported by records.
                  </i>
                </Alert>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    lineHeight: 1.5,
                  }}
                >
                  Example of Common M‑1 Adjustments
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Adjustment Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Book Treatment
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Tax Treatment
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Typical Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Depreciation</TableCell>
                          <TableCell>
                            Straight‑line expense over useful life
                          </TableCell>
                          <TableCell>Accelerated method</TableCell>
                          <TableCell>Taxable income decreases</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Meals & Entertainment</TableCell>
                          <TableCell>Deducted fully</TableCell>
                          <TableCell>50% deductible or disallowed</TableCell>
                          <TableCell>Taxable income increases</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Bad debts </TableCell>
                          <TableCell>Recorded on accrual</TableCell>
                          <TableCell>
                            Deductible only when written off
                          </TableCell>
                          <TableCell>Temporary timing difference</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Federal income tax </TableCell>
                          <TableCell>Expense recorded</TableCell>
                          <TableCell>Not deductible </TableCell>
                          <TableCell>Increases taxable income </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Tax‑exempt bond interest </TableCell>
                          <TableCell>Included in books</TableCell>
                          <TableCell>Excluded for tax </TableCell>
                          <TableCell>Decreases taxable income </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="relation"
                >
                  Relation to Schedules L and M‑2
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M‑1 directly ties to Schedule L (Balance Sheet per
                  Books) and Schedule M‑2 (Analysis of Accumulated Adjustments
                  Account):
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    Schedule L provides the beginning and ending balance sheet
                    figures from which book income is derived.
                  </li>
                  <li>
                    Schedule M‑1 translates those financial totals into tax
                    adjustments.
                  </li>
                  <li>
                    Schedule M‑2 explains how those adjustments affect the S
                    corporation’s accumulated earnings and distributions.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  The three schedules together show how your corporate income
                  flows from book accounting to taxable income to shareholder
                  equity.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Filing Deadlines
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M‑1 must be filed as part of Form 1120‑S by the
                  regular filing deadline for S‑corporations.
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline (Tax Year 2025)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporation </TableCell>
                          <TableCell>Form 1120‑S </TableCell>
                          <TableCell>March 16, 2026 * </TableCell>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography variant="body1" sx={{ mb: 3, fontStyle: 'italic' }}>
                  If March 15 falls on a weekend, the deadline moves to the next
                  business day. Filing Form 7004 gives a 6‑month extension—until
                  September 15, 2026.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Error
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Potential Issue
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Prevention Tip
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Skipping adjustments for tax‑exempt income
                          </TableCell>
                          <TableCell>Book‑tax mismatch </TableCell>
                          <TableCell>
                            Always list non‑taxable items clearly.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Incorrect depreciation treatment
                          </TableCell>
                          <TableCell>IRS adjustment risk</TableCell>
                          <TableCell>
                            Confirm methods per IRS Publication 946.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Double counting expenses</TableCell>
                          <TableCell>Overstated deductions</TableCell>
                          <TableCell>
                            Reconcile supporting ledgers with trial balance.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Mismatch between Schedules L, M‑1, and M‑2
                          </TableCell>
                          <TableCell>IRS queries or notices</TableCell>
                          <TableCell>
                            Align all values before filing electronically.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Schedule M‑1 Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Reconcile book income with tax income before preparing other
                    schedules.
                  </li>
                  <li>
                    Maintain detailed supporting documentation for each
                    reconciling item.
                  </li>
                  <li>
                    Check consistency between depreciation schedules, expense
                    categories, and financial statements.
                  </li>
                  <li>
                    Use TaxZerone’s e‑filing solution to auto‑populate Schedule
                    M‑1 from your bookkeeping data and ensure IRS‑ready
                    accuracy.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Why do book and tax income differ?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Accounting (GAAP) rules and tax laws recognize certain items
                  differently—Schedule M‑1 reconciles these variations to
                  explain the differences.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Is every S corporation required to file Schedule M‑1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Only S corporations with total assets or receipts of $250,000
                  or more at year‑end must file Schedule M‑1.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Does Schedule M‑1 affect shareholder taxes?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, indirectly. Accurate reconciliation ensures that the
                  income flowing through to Schedule K‑1 is correctly
                  calculated.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. What’s the connection between Schedule M‑1 and Schedule
                  M‑2?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M‑1 explains how book income converts to taxable
                  income, while Schedule M‑2 tracks those results in retained
                  earnings and shareholder equity accounts.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              File Your Form 1120‑S Including Schedule M‑1 with TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure complete, transparent reconciliation of your S
              corporation’s book and tax income with TaxZerone.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120schm1`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120SSchM1;
